// note: contains utility function like lodash.js
// todo: this should be move to some other location in a better way
const underscore = {
    // todo: very basic implementation without any typechecking
    firstIndex(items, predicate) {
        let selectedindex = -1;
        for (let i = 0; i < items.length; i++) {
            if (predicate(items[i])) {
                selectedindex = i;
                break;
            }
        }
        return selectedindex;
    },
    isFunction(func) {
        return typeof func === 'function';
    },
    // isArray: function (func) {
    //     // for safe-side for very old browsers like chrome 5 and current version is Chrome#90.
    //     if (typeof Array.isArray === 'undefined') {
    //         Array.isArray = function (obj) {
    //             return Object.prototype.toString.call(obj) === '[object Array]';
    //         }
    //     }
    //     return Array.isArray(func);
    // },
    isPlainObject(obj) {
        /**
         * Because of IE, we must also check the constructor properties to ensure that node objects and window objects are not passed.
         */
        if (!obj || typeof obj !== 'object' || obj.nodeType || underscore.isWindow(obj)) {
            return false;
        }
        try {
            // If obj has no constructor attribute and no obj in the prototype chain of obj returns false
            if (
                obj.constructor &&
                !underscore.hasOwn.call(obj, 'constructor') &&
                !underscore.hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')
            ) {
                return false;
            }
        } catch (e) {
            // IE8,9 will throw throw exceptions on certain host
            return false;
        }
        let key;
        for (key in obj) {
        }
        /**
         * If the key is not assigned, return fasle
         */
        return key === undefined || underscore.hasOwn.call(obj, key);
    },
    hasOwn:
        {}.hasOwnProperty ||
        function (prop) {
            if (prop in this) {
                const value = this[prop];

                if (!delete this[prop]) {
                    return true;
                }
                if (!(prop in this) || this[prop] !== value) {
                    this[prop] = value;
                    return true;
                }
            }
            return false;
        },
    isWindow(obj) {
        return obj != null && obj === obj.window;
    }
};
export default underscore;
